module.exports = "/next-static/_next/static/images/hero_image-1b7020abadfdf3509d2c51bc4614345a.png";